import { render } from "./GroupAdd.vue?vue&type=template&id=b4792dac&scoped=true"
import script from "./GroupAdd.vue?vue&type=script&lang=js"
export * from "./GroupAdd.vue?vue&type=script&lang=js"

import "./GroupAdd.vue?vue&type=style&index=0&id=b4792dac&lang=css"
import "./GroupAdd.vue?vue&type=style&index=1&id=b4792dac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4792dac"]])

export default __exports__